<template>
	<div class="schedule-bar">
		<div class="schedule-view-switch">
			<div class="schedule-view-switch-each" v-for="(item, index) in scheduleViewList" :key="index"
				v-if="switchMode == 1?index<3:switchMode == 2?index >=3:false"
				:class="item.isActive?'schedule-view-switch-each-active':''" @click="changeScheduleView(index)">
				<span>{{item.text}}</span>
			</div>
		</div>
		<div class="schedule-month-switch">
			<img v-if="switchMode == 1" @click="changeCalendarDate(1)"
				src="../../assets/common/icons/pointer_left.png" />
			<span>{{dateTime}}</span>
			<img v-if="switchMode == 1" @click="changeCalendarDate(2)"
				src="../../assets/common/icons/pointer_right.png" />
		</div>
		<div class="schedule-btns">
			<div class="add-schedule-btn" @click="showCreateSchedule">
				<img src="../../assets/common/icons/scheduleIcon_yellow.png" />
				<span>创建日程</span>
			</div>
		</div>
		<el-dialog :visible.sync="isShowEditSchedule" :close-on-click-modal="false">
			<div slot="title" class="dialog-title">
				<span>创建日程</span>
			</div>
			<editSchedule v-if="showEditSchedule" @confirmEditSchedule="confirmEditSchedule" :memberList="memberList"
				:useMode="'create'">
			</editSchedule>
		</el-dialog>
	</div>
</template>

<script>
	import editSchedule from '../schedule/EditSchedule.vue';
	export default {
		components: {
			editSchedule
		},
		props: {
			memberList: { //人员管理列表
				type: Array,
				default: []
			},
			switchMode: { //切换器模式：1-日/周/月；2-当前日程/以前的日程
				type: Number,
				default: 1
			}
		},
		data() {
			return {
				scheduleViewList: [], //日程视图列表-日、周、月
				dateTime: '', //当前视图日期
				isShowEditSchedule: false, //是否显示编辑日程弹窗
				showEditSchedule: false, //展示编辑日程弹窗（dialog中）
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {
				that.scheduleViewList = [{
					text: '日',
					isActive: false
				}, {
					text: '周',
					isActive: true
				}, {
					text: '月',
					isActive: false
				}, {
					text: '待办日程',
					isActive: true
				}, {
					text: '过往日程',
					isActive: false
				}];
				let date = new Date();
				that.dateTime = that.$utils.fmtDate(date, "yyyy年MM月");
				that.$bus.$on('updateTableDate', (dateTime) => {
					that.dateTime = that.$utils.fmtDate(dateTime, "yyyy年MM月");
				})
			})
		},
		methods: {
			//点击切换日程视图
			changeScheduleView(flag) {
				let that = this;
				that.scheduleViewList.forEach((item, index) => {
					item.isActive = false;
				})
				that.scheduleViewList[flag].isActive = true;
				that.$bus.$emit('changeScheduleView', flag);
			},
			//点击打开创建日程弹窗
			showCreateSchedule() {
				let that = this;
				that.isShowEditSchedule = true;
				that.showEditSchedule = true;
			},
			//点击完成创建日程
			confirmEditSchedule() {
				let that = this;
				that.isShowEditSchedule = false;
				that.showEditSchedule = false;
				that.$bus.$emit('updateScheduleList');
			},
			//点击切换日期
			changeCalendarDate(flag) {
				let that = this;
				that.$bus.$emit("changeCalendarDate", flag);
			}
		}
	}
</script>

<style lang="scss">
	.schedule-bar {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.schedule-view-switch {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		background-color: #D2E2FF;

		.schedule-view-switch-each {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			cursor: pointer;

			span {
				font-weight: 400;
				color: #666666;
			}
		}

		.schedule-view-switch-each-active {
			background-color: #1A66FE;

			span {
				color: #fff;
			}
		}
	}

	.schedule-month-switch {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;

		span {
			font-weight: 400;
			color: #666666;
		}

		img {
			cursor: pointer;
		}
	}

	.schedule-btns {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;

		.add-schedule-btn {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			background-color: #04BD63;
			cursor: pointer;

			img {}

			span {
				font-weight: 400;
				color: #FFFFFF;
			}
		}
	}

	.dialog-title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;

		span {
			font-weight: 400;
			color: #333333;
		}
	}

	@media screen and (min-width: 1024px) {
		.schedule-view-switch {
			border-radius: 9px;

			.schedule-view-switch-each {
				padding: 10px 36px;

				span {
					font-size: 14px;
				}
			}

			.schedule-view-switch-each-active {
				border-radius: 9px;
			}
		}

		.schedule-month-switch {
			img {
				width: 18px;
				height: 18px;
			}

			span {
				font-size: 18px;
				margin: 0 30px;
			}
		}

		.schedule-btns {
			.add-schedule-btn {
				border-radius: 9px;
				padding: 7px 16px;

				img {
					width: 22px;
					height: 22px;
					margin: 0 8px 0 0;
				}

				span {
					font-size: 15px;
				}
			}
		}

		.dialog-title {
			span {
				font-size: 18px;
			}
		}

		.el-dialog__headerbtn {
			font-size: 18px;
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.schedule-view-switch {
			border-radius: 14px;

			.schedule-view-switch-each {
				padding: 16px 60px;

				span {
					font-size: 24px;
				}
			}

			.schedule-view-switch-each-active {
				border-radius: 14px;
			}
		}

		.schedule-month-switch {
			img {
				width: 30px;
				height: 30px;
			}

			span {
				font-size: 29px;
				margin: 0 48px;
			}
		}

		.schedule-btns {
			.add-schedule-btn {
				border-radius: 14px;
				padding: 10px 22px;

				img {
					width: 40px;
					height: 40px;
					margin: 0 12px 0 0;
				}

				span {
					font-size: 25px;
				}
			}
		}

		.dialog-title {
			span {
				font-size: 29px;
			}
		}

		.el-dialog__headerbtn {
			font-size: 29px;
		}
	}

	@media screen and (min-width: 1920px) {}
</style>